import { useParseParams } from '@hooks/search-params';
import { PersonalAccidentQuoteResultPageParams, personalAccidentQuoteResultPageParamsSchema } from './route';

export const usePersonalAccidentQuoteResultPageParams = () =>
  useParseParams<Required<PersonalAccidentQuoteResultPageParams>>(personalAccidentQuoteResultPageParamsSchema);
